import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20abstract%20composition%20with%20warm%20orange%20and%20amber%20gradients%20flowing%20organically%2C%20soft%20cinematic%20light%20rays%2C%20modern%20tech%20aesthetic%20with%20smooth%20curves%20and%20dynamic%20energy%2C%20dark%20edges%20with%20warm%20center%20glow%2C%20digital%20media%20concept%20art&width=1920&height=1200&seq=hero-bg-kuaimao&orientation=landscape"
          alt="快猫短视频 - 发现精彩"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 mb-8">
          <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
          <span className="text-sm text-background-50/90">V8.0 全新版本已发布</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold font-heading text-background-50 mb-6 leading-tight">
          {heroData.title}
        </h1>
        <p className="text-xl md:text-2xl text-background-50/90 font-medium mb-4">
          {heroData.subtitle}
        </p>
        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          {heroData.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          {heroData.downloadButtons.map((btn) => (
            <a
              key={btn.label}
              href={btn.href}
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 active:scale-95"
            >
              <i className={`${btn.icon} text-lg`}></i>
              {btn.label}
            </a>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {heroData.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-extrabold text-background-50 mb-1 font-heading">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-50/60">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}